function chooseOne(options: string[]) {
    return options[Math.floor(Math.random() * options.length)]
}

function makeAttribute(attribute: string, path: string, asset: string) {
    if (asset.length === 0) return attribute + ':None';
    return attribute + ':' + asset.replace(path, '').replaceAll('-', ' ').replace('.png', '');
}

function nonVisualAttribute(attribute: string, options: string[]) {
    return attribute + ':' + chooseOne(options);
}

export function randomizerBiznessmen(filenames : string[]) : {images: string[], attributes: string[] } {
    let backAssets = filenames.filter(a => a.startsWith('Back/'));
    let backgroundAssets = filenames.filter(a => a.startsWith('Background/'));
    let eyesAssets = filenames.filter(a => a.startsWith('Eyes/'));
    let faceAssets = filenames.filter(a => a.startsWith('Face/'));
    let facialHairAssets = filenames.filter(a => a.startsWith('Facial Hair/'));
    let glassesAssets = filenames.filter(a => a.startsWith('Glasses/'));
    let hairAssets = filenames.filter(a => a.startsWith('Hair/'));
    let hatAssets = filenames.filter(a => a.startsWith('Hats/'));
    let mouthAssets = filenames.filter(a => a.startsWith('Mouth/'));
    let shirtAssets = filenames.filter(a => a.startsWith('Shirts/'));
    let suitAssets = filenames.filter(a => a.startsWith('Suits/'));
    let tieAssets = filenames.filter(a => a.startsWith('Ties/'));

    let backAsset = chooseOne(backAssets);
    let backgroundAsset = chooseOne(backgroundAssets);
    let eyesAsset = chooseOne(eyesAssets);
    let faceAsset = chooseOne(faceAssets);
    let facialHairAsset = chooseOne(facialHairAssets);
    let glassesAsset = chooseOne(glassesAssets);
    let hairAsset = chooseOne(hairAssets);
    let hatAsset = chooseOne(hatAssets);
    let mouthAsset = chooseOne(mouthAssets);
    let shirtAsset = chooseOne(shirtAssets);
    let suitAsset = chooseOne(suitAssets);
    let tieAsset = chooseOne(tieAssets);

    // custom rules to prevent graphical clashes

    let assets = [
        backgroundAsset, backAsset, faceAsset, eyesAsset, hairAsset, facialHairAsset, mouthAsset, glassesAsset, hatAsset, shirtAsset, suitAsset, tieAsset
    ];

    console.log(assets);

    let images = assets.filter(a => a.length > 0).map(a => '/biznessmen/' + a);

    let hometowns = ['Los Angeles', 'Atlana', 'New York', 'Chicago', 'Tokyo', 'Sydney', 'Buenos Aires', 'London', 'Frankfurt', 'Istanbul'];
    let favoriteFoods = ['Tacos', 'Hot dogs', 'Pizza', 'Steak', 'Sushi', 'Pasta'];

    let attributes = [
        makeAttribute('BACKGROUND', 'Background/', backgroundAsset),
        makeAttribute('BACK', 'Back/', backAsset),
        makeAttribute('EYES', 'Eyes/', eyesAsset),
        makeAttribute('FACE', 'Face/', faceAsset),
        makeAttribute('FACIAL HAIR', 'Facial Hair/', facialHairAsset),
        nonVisualAttribute('FAVORITE FOOD', favoriteFoods),
        makeAttribute('GLASSES', 'Glasses/', glassesAsset),
        makeAttribute('HAIR', 'Hair/', hairAsset),
        makeAttribute('HAT', 'Hats/', hatAsset),
        nonVisualAttribute('HOMETOWN', hometowns),
        makeAttribute('MOUTH', 'Mouth/', mouthAsset),
        makeAttribute('SHIRT', 'Shirts/', shirtAsset),
        makeAttribute('SUIT', 'Suits/', suitAsset),
        makeAttribute('TIE', 'Ties/', tieAsset),
    ];

    console.log(attributes);

    return {images: images, attributes: attributes};
}
